import { render, staticRenderFns } from "./ChangeZoom.vue?vue&type=template&id=6ab17358"
import script from "./ChangeZoom.vue?vue&type=script&lang=js"
export * from "./ChangeZoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports